// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageOption_wrapper__0ctns","picture":"ImageOption_picture__48420","text":"ImageOption_text__15yET"};